import { ReactElement } from 'react';
import { DataGridToolbarActions } from './DataGridToolbarActions';

export function CommonDataGridActions(): ReactElement {
  return <DataGridToolbarActions />;
}

